/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateReservationRequestGatewayInfoRiskData } from './CreateReservationRequestGatewayInfoRiskData';
import {
    CreateReservationRequestGatewayInfoRiskDataFromJSON,
    CreateReservationRequestGatewayInfoRiskDataFromJSONTyped,
    CreateReservationRequestGatewayInfoRiskDataToJSON,
    CreateReservationRequestGatewayInfoRiskDataToJSONTyped,
} from './CreateReservationRequestGatewayInfoRiskData';
import type { CreateReservationRequestGatewayInfoBrowserInfo } from './CreateReservationRequestGatewayInfoBrowserInfo';
import {
    CreateReservationRequestGatewayInfoBrowserInfoFromJSON,
    CreateReservationRequestGatewayInfoBrowserInfoFromJSONTyped,
    CreateReservationRequestGatewayInfoBrowserInfoToJSON,
    CreateReservationRequestGatewayInfoBrowserInfoToJSONTyped,
} from './CreateReservationRequestGatewayInfoBrowserInfo';
import type { CreateReservationRequestGatewayInfoOrder } from './CreateReservationRequestGatewayInfoOrder';
import {
    CreateReservationRequestGatewayInfoOrderFromJSON,
    CreateReservationRequestGatewayInfoOrderFromJSONTyped,
    CreateReservationRequestGatewayInfoOrderToJSON,
    CreateReservationRequestGatewayInfoOrderToJSONTyped,
} from './CreateReservationRequestGatewayInfoOrder';

/**
 * 
 * @export
 * @interface CreateReservationRequestGatewayInfo
 */
export interface CreateReservationRequestGatewayInfo {
    /**
     * 
     * @type {CreateReservationRequestGatewayInfoRiskData}
     * @memberof CreateReservationRequestGatewayInfo
     */
    riskData?: CreateReservationRequestGatewayInfoRiskData;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestGatewayInfo
     */
    origin?: string;
    /**
     * 
     * @type {CreateReservationRequestGatewayInfoOrder}
     * @memberof CreateReservationRequestGatewayInfo
     */
    order?: CreateReservationRequestGatewayInfoOrder;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReservationRequestGatewayInfo
     */
    clientStateDataIndicator: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateReservationRequestGatewayInfo
     */
    sessionData?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateReservationRequestGatewayInfo
     */
    storePaymentMethod?: boolean;
    /**
     * 
     * @type {any}
     * @memberof CreateReservationRequestGatewayInfo
     */
    paymentMethod: any | null;
    /**
     * 
     * @type {CreateReservationRequestGatewayInfoBrowserInfo}
     * @memberof CreateReservationRequestGatewayInfo
     */
    browserInfo?: CreateReservationRequestGatewayInfoBrowserInfo;
}

/**
 * Check if a given object implements the CreateReservationRequestGatewayInfo interface.
 */
export function instanceOfCreateReservationRequestGatewayInfo(value: object): value is CreateReservationRequestGatewayInfo {
    if (!('clientStateDataIndicator' in value) || value['clientStateDataIndicator'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    return true;
}

export function CreateReservationRequestGatewayInfoFromJSON(json: any): CreateReservationRequestGatewayInfo {
    return CreateReservationRequestGatewayInfoFromJSONTyped(json, false);
}

export function CreateReservationRequestGatewayInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReservationRequestGatewayInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'riskData': json['riskData'] == null ? undefined : CreateReservationRequestGatewayInfoRiskDataFromJSON(json['riskData']),
        'origin': json['origin'] == null ? undefined : json['origin'],
        'order': json['order'] == null ? undefined : CreateReservationRequestGatewayInfoOrderFromJSON(json['order']),
        'clientStateDataIndicator': json['clientStateDataIndicator'],
        'sessionData': json['sessionData'] == null ? undefined : json['sessionData'],
        'storePaymentMethod': json['storePaymentMethod'] == null ? undefined : json['storePaymentMethod'],
        'paymentMethod': json['paymentMethod'],
        'browserInfo': json['browserInfo'] == null ? undefined : CreateReservationRequestGatewayInfoBrowserInfoFromJSON(json['browserInfo']),
    };
}

export function CreateReservationRequestGatewayInfoToJSON(json: any): CreateReservationRequestGatewayInfo {
    return CreateReservationRequestGatewayInfoToJSONTyped(json, false);
}

export function CreateReservationRequestGatewayInfoToJSONTyped(value?: CreateReservationRequestGatewayInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'riskData': CreateReservationRequestGatewayInfoRiskDataToJSON(value['riskData']),
        'origin': value['origin'],
        'order': CreateReservationRequestGatewayInfoOrderToJSON(value['order']),
        'clientStateDataIndicator': value['clientStateDataIndicator'],
        'sessionData': value['sessionData'],
        'storePaymentMethod': value['storePaymentMethod'],
        'paymentMethod': value['paymentMethod'],
        'browserInfo': CreateReservationRequestGatewayInfoBrowserInfoToJSON(value['browserInfo']),
    };
}

